// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xn1w","colBig":"styles_colBig__1-8gy","colSmall":"styles_colSmall__3fnqx"};